import { Box, Button, Typography } from '@mui/material'
import React from 'react'

interface Props {
  title: string
  /** Short highlight above the description, as on the adoption request card. */
  chip?: string
  description: React.ReactNode
  /** Drawn as chosen. Left out where the card is an action rather than a choice. */
  selected?: boolean
  disabled?: boolean
  onClick: () => void
}

/**
 * The two ways an adoption can be recorded, as the adopter creation screen presents them. Shared so
 * the same choice does not appear as two plain buttons in one place and as described cards in
 * another.
 */
export const AdoptionTypeCard: React.FC<Props> = ({ title, chip, description, selected, disabled, onClick }) => (
  <Button
    type="button"
    variant="outlined"
    disabled={disabled}
    onClick={onClick}
    sx={{
      justifyContent: 'flex-start',
      textTransform: 'none',
      textAlign: 'left',
      minHeight: 108,
      borderRadius: 3,
      px: 2,
      py: 1.75,
      fontWeight: 700,
      boxShadow: 'none',
      borderColor: selected ? '#3B76D3' : '#CFE0FB',
      backgroundColor: selected ? '#E8F1FF' : '#F7FAFF',
      color: '#203864',
      '&:hover': { borderColor: '#3B76D3', backgroundColor: '#E8F1FF', boxShadow: 'none' },
    }}
  >
    <Box>
      <Typography sx={{ fontSize: '0.98rem', fontWeight: 800, color: '#203864' }}>{title}</Typography>
      {chip && (
        // A span rather than a Chip: this sits inside a Button, which may not nest interactive content.
        <Box
          component="span"
          sx={{
            display: 'inline-block',
            mt: 0.6,
            px: 1,
            py: 0.25,
            borderRadius: 999,
            backgroundColor: '#E8F1FF',
            border: '1px solid #CFE0FB',
            color: '#203864',
            fontSize: '0.68rem',
            fontWeight: 700,
            lineHeight: 1.5,
          }}
        >
          {chip}
        </Box>
      )}
      <Typography sx={{ mt: 0.5, fontSize: '0.74rem', fontWeight: 500, color: '#5D6785', lineHeight: 1.35 }}>
        {description}
      </Typography>
    </Box>
  </Button>
)

export const ADOPTION_REQUEST_CHIP = "Recevez les frais d'adoption via paiement en ligne"
